export const ApiUrls = {
    //* Contrôles : Check templates
    CHECK_TEMPLATE_LIST: '/api/v1/back/check_templates',
    CHECK_TEMPLATE_DETAILS: (id: string): string => `${ApiUrls.CHECK_TEMPLATE_LIST}/${id}`,

    //* Obtient le PDF d'un controle.
    CHECK_EXPORT_PDF: (id: string) => `/api/v1/back/checks/${id}/pdf`,

    //* Obtient le PDF d'une signature.
    EXPORT_POINTAGES_SIGNTURE: (compagnon_id: string, signature_id: string) =>
        `/api/v1/back/compagnons/${compagnon_id}/pointages/signatures/${signature_id}/pdf`,
};
